import { STANDARD_TRACKING_LINK_MAP, TRANSLATE_PREFIX } from '../../consts';
import { SERVER_SIDE_METHODS } from './consts';
import CategoryCell from './CategoryCell';
import FieldNameCell from './FieldNameCell';
import DescriptionCell from './DescriptionCell';
import SingularKeyCell from './SingularKeyCell';
import MacroCell from './MacroCell';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

export const isServerSideMethod = method => SERVER_SIDE_METHODS.includes(method);
export const isCustomParam = p => !STANDARD_TRACKING_LINK_MAP[p.singular_key];

export const getTableMetadata = ({ sharedCellProps, readOnly, onDelete }) => [
    {
        name: 'category',
        displayName: `${TAB_PREFIX}.TABLE_CATEGORY`,
        cellComponent: CategoryCell,
        cellProps: { readOnly, onDelete },
        headerWidth: 120,
    },
    {
        name: 'field_name',
        displayName: `${TAB_PREFIX}.TABLE_FIELD_NAME`,
        cellComponent: FieldNameCell,
        cellProps: sharedCellProps,
        headerWidth: 200,
    },
    {
        name: 'description',
        displayName: `${TAB_PREFIX}.TABLE_DESCRIPTION`,
        cellComponent: DescriptionCell,
        cellProps: sharedCellProps,
    },
    {
        name: 'singular_key',
        displayName: `${TAB_PREFIX}.TABLE_SINGULAR_KEY`,
        cellComponent: SingularKeyCell,
        cellProps: sharedCellProps,
        headerWidth: 175,
    },
    {
        name: 'partner_macro',
        displayName: `${TAB_PREFIX}.TABLE_YOUR_MACRO`,
        cellComponent: MacroCell,
        cellProps: sharedCellProps,
        headerWidth: 250,
    },
];
